import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import TableComponent from "../../components/TableComponent";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`loyalty-tabpanel-${index}`}
      aria-labelledby={`loyalty-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `loyalty-tab-${index}`,
    "aria-controls": `loyalty-tabpanel-${index}`,
  };
}

// Sample loyalty point transactions
const loyaltyRows = [
  { id: 1, date: "2025-01-10", type: "Earned", points: 100, status: "Active" },
  { id: 2, date: "2025-02-05", type: "Redeemed", points: -50, status: "Used" },
  { id: 3, date: "2025-03-12", type: "Expired", points: -20, status: "Expired" },
];

const loyaltyColumns = [
  { field: "date", headerName: "Date", flex: 1, minWidth: 150 },
  { field: "type", headerName: "Transaction Type", flex: 1, minWidth: 150 },
  { field: "points", headerName: "Points", flex: 1, minWidth: 120 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 120 },
];

const RecommendedVenueDetails = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = useState(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Loyalty Points Details</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-customers")}>Manage Customers</span>
          {' '} - Loyalty Points
        </p>
      </div>

      <div className="table_header">
        <Box className="custom_tabs1" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="loyalty tabs"
            className="custom_tabs_links"
          >
            <Tab label="Customer Info" {...a11yProps(0)} />
            <Tab label="Point Transactions" {...a11yProps(1)} />
          </Tabs>
        </Box>
      </div>

      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="section_title">
            <h2>Customer Info</h2>
          </div>
          <div className="gap_p">
            <div className="vew_img w_100">
              <h6>Image</h6>
              <figure>
                <img alt="user" src="/static/images/user_placeholder.png" />
              </figure>
            </div>
            <div className="w_33">
              <h6>Name</h6>
              <p>Madelyn Dias</p>
            </div>
            <div className="w_33">
              <h6>Email Id</h6>
              <p>madelyndias@gmail.com</p>
            </div>
            <div className="w_33">
              <h6>Phone Number</h6>
              <p>9876543210</p>
            </div>
            <div className="w_33">
              <h6>Total Points</h6>
              <p>130</p>
            </div>
            <div className="w_33">
              <h6>Points Expired</h6>
              <p>20</p>
            </div>
            <div className="w_33">
              <h6>Points Redeemed</h6>
              <p>50</p>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="sorting_table">
            <TableComponent columns={loyaltyColumns} rows={loyaltyRows} />
          </div>
        </div>
      </CustomTabPanel>
    </MainContainer>
  );
};

export default RecommendedVenueDetails;
